import videos from './videos'
import user from './user'
import training from './training'
import message from './message'
import application from './application'
import interview from './interview'
import contract from './contract'
import settings from './settings'

export default {
  videos,
  user,
  training,
  message,
  application,
  interview,
  contract,
  settings,
}

// 也可以单独导出
export { videos, user, training, message, application, interview, contract, settings }
